export default __webpack_public_path__ + "static/media/AniaLogo-full.5c484879.svg";